<template>
<div class="height-100">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: "OwnerIndex"
}
</script>

<style scoped>

</style>
